const POST_DATA_URL = process.env["REACT_APP_API_URL_PREFIX"] + "/post_data_goepiq.php";

async function postData( data = {}) {
    // Default options are marked with *
    const response = await fetch(POST_DATA_URL, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'no-cors', // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
        .then((res) => res.json());

    // return await response.json(); // parses JSON response into native JavaScript objects
    return response;
}

export default postData;
